const radii = {
  none: "0",
  "ms-2": "0.125rem",
  "ms-4": "0.25rem",
  "ms-6": "0.375rem",
  "ms-8": "0.5rem",
  "ms-12": "0.75rem",
  "ms-16": "1rem",
  "ms-24": "1.5rem",
  "ms-100": "6.25rem",
  full: "9999px",
};

export default radii;
